// import React, { useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
// import { useNavigate } from 'react-router-dom';
// import { AuthContext } from '../../auth/authContext';
// import { types } from '../../types/types';
import './navbar.css';

export const Navbar = () => {
  // const { user, dispatch } = useContext(AuthContext);
  // const navigate = useNavigate();

  // const handleLogout = () => {
  //   dispatch({
  //     type: types.logout,
  //   });

  //   navigate('/login', {
  //     replace: true,
  //   });
  // };

  return (
    <nav className="navbar navbar-expand navbar-dark bg-dark">
      <Link className="navbar-brand" to="/">
        <img className="navbar-imgLogo" src="/heroes.svg" alt="logoHeroes" />
      </Link>

      <div className="navbar-collapse">
        <div className="navbar-nav">
          <NavLink
            // className={({ isActive }) =>
            //   "nav-item nav-link" + (isActive ? "active" : "")
            // }
            className="nav-item nav-link"
            to="/marvel"
          >
            Marvel
          </NavLink>

          <NavLink
            // className={({ isActive }) =>
            //   "nav-item nav-link" + (isActive ? "active" : "")
            // }
            className="nav-item nav-link"
            to="/dc"
          >
            DC
          </NavLink>

          <NavLink
            // className={({ isActive }) =>
            //   "nav-item nav-link" + (isActive ? "active" : "")
            // }
            className="nav-item nav-link"
            to="/search"
          >
            Search
          </NavLink>
        </div>
      </div>

      <div className="navbar-collapse collapse w-100 order-3 dual-collapse2 d-flex justify-content-end">
        <ul className="navbar-nav ml-auto">
          <span className="nav-item nav-link text-info">Tobias Ajras</span>
          {/* <button className="nav-item nav-link btn" onClick={handleLogout}>
            Logout
          </button> */}
        </ul>
      </div>
    </nav>
  );
};
